import { FC } from "react";
import { StatisticsObjectType } from "../caseVolumeLineChart/types";
import { formatStatistics } from "src/helpers";


const CustomComponentForTransfer: FC<StatisticsObjectType> = ({ StatisticsObjectType }): JSX.Element => {


  return (
    <div className="row">
      <div className="col-12 col-sm-12 col-md-6">
        <div className="card">
          <div className="card-header">
            <p className="m-0 text-center text-primary fs-2 fw-bold">Transfers (vs previous year)</p>
          </div>
          <div className="card-body">
            <p className="text-center fw-bold mb-0 fs-1">
              {formatStatistics(StatisticsObjectType.transfers_vs_previous_year)}
            </p>
          </div>
        </div>
      </div>
      <div className="col-12 col-sm-12 col-md-6">
        <div className="card">
          <div className="card-header">
            <p className="m-0 text-center text-primary fs-2 fw-bold">Case Volume (vs previous year)</p>
          </div>
          <div className="card-body">
            <p className="text-center fw-bold mb-0 fs-1" style={{ color: "rgb(144, 237, 125)" }}>
              {formatStatistics(StatisticsObjectType.case_vol_vs_previous_year, { showPercentage: false })}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomComponentForTransfer;
